import { useState, useCallback } from 'react';
import { saveAs } from 'file-saver';

import { exportConsumptions } from '@/api/services/consumer/consumer.service';

import type { ConsumerUrls } from '../types/consumer.types';

export const useConsumerExport = (urls: ConsumerUrls | null) => {
  const [isExporting, setIsExporting] = useState(false);

  const exportData = useCallback(async (): Promise<void> => {
    if (!urls?.exportUrl) return;

    setIsExporting(true);
    try {
      const { blob, filename } = await exportConsumptions(urls.exportUrl);
      saveAs(blob, filename);
    } finally {
      setIsExporting(false);
    }
  }, [urls?.exportUrl]);

  return { isExporting, exportData };
};
